import { render, staticRenderFns } from "./prorepair.vue?vue&type=template&id=60d4abb0&scoped=true&"
import script from "./prorepair.vue?vue&type=script&lang=js&"
export * from "./prorepair.vue?vue&type=script&lang=js&"
import style0 from "./prorepair.vue?vue&type=style&index=0&id=60d4abb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4abb0",
  null
  
)

export default component.exports